import { RefreshCw } from "lucide-react";

export default function ErrorState({ message = "Unable to connect to the server.", onRetry }) {
  return (
    <div className="text-center py-16">
      <p className="text-sm text-red-600 mb-3">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="inline-flex items-center gap-1.5 text-sm font-medium text-neutral-700 border border-neutral-300 rounded-lg px-3 py-1.5 hover:bg-neutral-50"
        >
          <RefreshCw size={14} />
          Retry
        </button>
      )}
    </div>
  );
}
